import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(_ctx.classes)
    }, [
      (_ctx.previous)
        ? (_openBlock(), _createBlock(_component_oxd_icon, {
            key: 0,
            name: "chevron-left"
          }))
        : (_ctx.next)
          ? (_openBlock(), _createBlock(_component_oxd_icon, {
              key: 1,
              name: "chevron-right"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.page), 1)
            ], 64))
    ], 2)
  ]))
}